const centura_webshop = window.centura_webshop || {};
window.centura_webshop = centura_webshop;

centura_webshop.cart = {
    _cart_items: {},

    _parse_cart_error(r) {
        let message = __('Something went wrong while updating the cart.');
        try {
            if (r.responseJSON?._server_messages) {
                message = JSON.parse(
                    JSON.parse(r.responseJSON._server_messages)[0]
                ).message;
            }
        } catch (e) {
            console.error(e);
        }
        return message;
    },

    update_cart(item_code, qty, additional_notes, callback, on_error) {
        frappe.call({
            method: 'centura_webshop.cart.cart.update_cart',
            args: { item_code, qty, additional_notes },
            error: (r) => {
                frappe.msgprint({
                    title: __('Error'),
                    indicator: 'red',
                    message: centura_webshop.cart._parse_cart_error(r)
                });
                if (on_error) on_error(r);
            },
            callback(r) {
                if (r.exc) {
                    if (on_error) on_error(r);
                    return;
                }
                const msg = r.message || {};
                centura_webshop.cart._cart_items = msg.cart_items || {};
                centura_webshop.cart._update_cart_count(msg.cart_count || 0);
                centura_webshop.cart._sync_card_indicators();
                if (callback) callback(r);
            }
        });
    },

    add_to_cart(item_code, qty = 1) {
        const current = centura_webshop.cart._cart_items[item_code] || 0;
        const new_qty = current + qty;

        if (frappe.session.user === 'Guest') {
            centura_webshop.cart._add_to_guest_cart(item_code, new_qty);
            return;
        }
        centura_webshop.cart.update_cart(item_code, new_qty);
    },

    remove_from_cart(item_code) {
        centura_webshop.cart.update_cart(item_code, 0);
    },

    _add_to_guest_cart(item_code, qty) {
        frappe.call({
            method: 'centura_webshop.cart.cart.add_to_guest_cart',
            args: { item_code, qty },
            error: (r) => {
                frappe.msgprint({
                    title: __('Error'),
                    indicator: 'red',
                    message: centura_webshop.cart._parse_cart_error(r)
                });
            },
            callback(r) {
                if (r.exc) return;
                const msg = r.message || {};
                centura_webshop.cart._cart_items = msg.cart_items || {};
                centura_webshop.cart._update_cart_count(msg.cart_count || 0);
                centura_webshop.cart._sync_card_indicators();
            }
        });
    },

    fetch_cart_items(callback) {
        frappe.call({
            method: 'centura_webshop.cart.cart.get_cart_items',
            callback(r) {
                if (r.message) {
                    centura_webshop.cart._cart_items = r.message;
                }
                centura_webshop.cart._sync_card_indicators();
                if (callback) callback(centura_webshop.cart._cart_items);
            }
        });
    },

    _sync_card_indicators() {
        const items = centura_webshop.cart._cart_items;
        document.querySelectorAll('.webshop-product-card').forEach((card) => {
            const item_code = card.dataset.itemCode;
            const qty = items[item_code] || 0;

            const badge = card.querySelector('.webshop-cart-qty-badge');
            if (badge) {
                badge.textContent = qty;
                badge.style.display = qty > 0 ? 'flex' : 'none';
            }

            const btn = card.querySelector('.webshop-btn-add-to-cart');
            if (btn && !btn.disabled) {
                btn.textContent = qty > 0 ? __('Add More') : __('Add to Cart');
            }
        });
    },

    _update_cart_count(count) {
        const badge = document.querySelector('.webshop-cart-count');
        if (badge) {
            badge.textContent = count;
            badge.style.display = count > 0 ? 'inline-flex' : 'none';
            badge.classList.add('webshop-animate-wiggle');
            setTimeout(
                () => badge.classList.remove('webshop-animate-wiggle'),
                500
            );
        }

        if (window.location.pathname.includes('/shop/cart')) {
            document.title =
                count > 0
                    ? `(${count}) ${__('Cart')} - ${frappe.boot.sitename}`
                    : `${__('Cart')} - ${frappe.boot.sitename}`;
        }
    },

    _init_navbar_icons() {
        if (frappe.session.user === 'Guest') return;

        const target = document.querySelector(
            '.navbar-nav.ms-auto, .navbar-nav:last-child, .navbar-nav.ml-auto'
        );
        if (!target) return;

        const enable_favorites =
            frappe.get_cookie('ew_enable_favorites') !== '0';

        // Find the login/user dropdown as an anchor point (insert before it)
        const loginItem =
            target.querySelector('.nav-item:last-child') ||
            target.querySelector('[href="/login"]')?.closest('.nav-item');

        // Add favorites link to navbar if not present
        if (
            enable_favorites &&
            !document.querySelector('.webshop-navbar-fav')
        ) {
            const favLink = document.createElement('li');
            favLink.className = 'nav-item';
            const favA = document.createElement('a');
            favA.href = '/shop/favorites';
            favA.className = 'webshop-navbar-fav nav-link';
            favA.title = __('My Favorites');
            const favCount = parseInt(frappe.get_cookie('ew_fav_count')) || 0;
            favA.innerHTML =
                '\u2665' +
                `<span class="webshop-fav-count" style="display:${
                    favCount > 0 ? 'inline-flex' : 'none'
                }">${favCount}</span>`;
            favLink.appendChild(favA);
            if (loginItem) {
                loginItem.before(favLink);
            } else {
                target.appendChild(favLink);
            }
        }

        // Add cart link to navbar if not present
        if (!document.querySelector('.webshop-navbar-cart')) {
            const cartLink = document.createElement('li');
            cartLink.className = 'nav-item';
            const cartA = document.createElement('a');
            cartA.href = '/shop/cart';
            cartA.className = 'webshop-navbar-cart nav-link';
            cartA.title = __('Cart');
            const cartCount = parseInt(frappe.get_cookie('ew_cart_count')) || 0;
            cartA.innerHTML =
                `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>` +
                `<span class="webshop-cart-count" style="display:${
                    cartCount > 0 ? 'inline-flex' : 'none'
                }">${cartCount}</span>`;
            cartLink.appendChild(cartA);
            // Insert cart right after favorites
            const favItem = document
                .querySelector('.webshop-navbar-fav')
                ?.closest('.nav-item');
            if (favItem) {
                favItem.after(cartLink);
            } else if (loginItem) {
                loginItem.before(cartLink);
            } else {
                target.appendChild(cartLink);
            }
        }
    },

    _init_favorites() {
        // Mark already-favorited items
        if (frappe.session.user !== 'Guest') {
            frappe.call({
                method: 'centura_webshop.api.get_user_favorites',
                callback: (r) => {
                    if (r.exc || !r.message) return;
                    const favorites = r.message;
                    document
                        .querySelectorAll('.webshop-btn-favorite')
                        .forEach((btn) => {
                            const item_code = btn.dataset.itemCode;
                            if (favorites.includes(item_code)) {
                                btn.classList.add('active');
                                btn.innerHTML = '\u2665';
                                btn.title = __('Remove from Favorites');
                            }
                        });
                    centura_webshop.cart._user_favorites = favorites;
                }
            });
        }
    },

    _update_fav_count(count) {
        const badge = document.querySelector('.webshop-fav-count');
        if (badge) {
            badge.textContent = count;
            badge.style.display = count > 0 ? 'inline-flex' : 'none';
        }
    },

    _show_toast(message) {
        let toast = document.querySelector('.webshop-toast');
        if (!toast) {
            toast = document.createElement('div');
            toast.className = 'webshop-toast';
            document.body.appendChild(toast);
        }
        toast.textContent = message;
        toast.classList.add('show');
        setTimeout(() => toast.classList.remove('show'), 2500);
    },

    apply_coupon_code(code) {
        return frappe.call({
            method: 'centura_webshop.cart.cart.apply_coupon_code',
            args: { applied_code: code }
        });
    },

    remove_coupon_code() {
        return frappe.call({
            method: 'centura_webshop.cart.cart.remove_coupon_code'
        });
    },

    _parse_server_message(r) {
        let message = __('Something went wrong while placing your order.');
        try {
            if (r.responseJSON?._server_messages) {
                message = JSON.parse(
                    JSON.parse(r.responseJSON._server_messages)[0]
                ).message;
            }
        } catch (e) {
            console.error(e);
        }
        return message;
    },

    _show_place_order_error(message) {
        frappe.msgprint({
            title: __('Error'),
            indicator: 'red',
            message
        });
    },

    _set_place_order_enabled(enabled) {
        const btn = document.querySelector('.webshop-btn-place-order');
        if (btn) {
            btn.disabled = !enabled;
        }
    },

    place_order() {
        centura_webshop.cart._set_place_order_enabled(false);
        frappe.freeze(__('Placing your order...'));

        return new Promise((resolve, reject) => {
            frappe.call({
                method: 'centura_webshop.cart.cart.place_order',
                error(r) {
                    frappe.unfreeze();
                    centura_webshop.cart._show_place_order_error(
                        centura_webshop.cart._parse_server_message(r)
                    );
                    centura_webshop.cart._set_place_order_enabled(true);
                    reject(r);
                },
                callback(r) {
                    if (r.exc) {
                        frappe.unfreeze();
                        centura_webshop.cart._set_place_order_enabled(true);
                        reject(r);
                        return;
                    }

                    const msg = r.message || {};
                    if (msg.status === 'complete' && msg.sales_order) {
                        frappe.unfreeze();
                        resolve({ message: msg.sales_order });
                        return;
                    }

                    if (typeof msg === 'string' && msg) {
                        frappe.unfreeze();
                        resolve({ message: msg });
                        return;
                    }

                    frappe.unfreeze();
                    centura_webshop.cart._show_place_order_error(
                        __('Order could not be completed.')
                    );
                    centura_webshop.cart._set_place_order_enabled(true);
                    reject(r);
                }
            });
        });
    }
};

frappe.ready(() => {
    centura_webshop.cart.fetch_cart_items();

    $(document).on('click', '.webshop-btn-add-to-cart', function () {
        const item_code = $(this).data('item-code');
        const qty =
            parseInt(
                $(this)
                    .closest(
                        '.webshop-product-actions, .webshop-add-to-cart-section'
                    )
                    .find('.webshop-qty-input, .webshop-card-qty-input')
                    .val()
            ) || 1;
        centura_webshop.cart.add_to_cart(item_code, qty);
    });

    $(document).on('click', '.webshop-card-qty-minus', function () {
        const input = $(this).siblings('.webshop-card-qty-input');
        const val = parseInt(input.val()) || 1;
        if (val > 1) input.val(val - 1);
    });
    $(document).on('click', '.webshop-card-qty-plus', function () {
        const input = $(this).siblings('.webshop-card-qty-input');
        const val = parseInt(input.val()) || 1;
        const max = parseInt(input.attr('max')) || 9999;
        if (val < max) input.val(val + 1);
    });

    $(document).on('click', '.webshop-btn-favorite', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $btn = $(this);
        const item_code = $btn.data('item-code');
        const is_favorited = $btn.hasClass('active');

        if (frappe.session.user === 'Guest') {
            window.location.href = `/login?redirect-to=${encodeURIComponent(
                window.location.pathname
            )}`;
            return;
        }

        const method = is_favorited
            ? 'centura_webshop.api.remove_from_favorites'
            : 'centura_webshop.api.add_to_favorites';

        frappe.call({
            method,
            args: { item_code },
            callback: (r) => {
                if (r.exc) return;
                const now_active = !is_favorited;
                // Update ALL favorite buttons for this item_code
                $(
                    `.webshop-btn-favorite[data-item-code="${$.escapeSelector(
                        item_code
                    )}"]`
                ).each(function () {
                    $(this).toggleClass('active', now_active);
                    $(this).html(now_active ? '\u2665' : '\u2661');
                    $(this).attr(
                        'title',
                        now_active
                            ? __('Remove from Favorites')
                            : __('Add to Favorites')
                    );
                });
                centura_webshop.cart._update_fav_count(
                    r.message?.fav_count || 0
                );
            }
        });
    });

    // Initialize navbar icons (favorites + cart) and favorite states
    centura_webshop.cart._init_navbar_icons();
    centura_webshop.cart._init_favorites();
});
